import Emitter from "es6-event-emitter";
import { injectDidomiScript } from "../utilities/DOMUtils";

export default class Didomi extends Emitter {
  constructor(options) {
    super();
    this.didomi = null;
    this._options = options;
    if (options.key) {
      injectDidomiScript(options.key);
    } else {
      if (window.Didomi) {
        this.didomi = window.Didomi;
        this.trigger("cmp:loaded");
      }
    }
    this._eventHandlers();
  }

  _eventHandlers() {
    //listening to user consent changed
    window.didomiEventListeners = window.didomiEventListeners || [];
    //listen to didomi script loading
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push((Didomi) => {
      this.didomi = Didomi;
      this.trigger("cmp:loaded");
    });

    window.didomiEventListeners.push({
      event: "consent.changed",
      listener: () => {
        this.trigger("userConsent:changed");
      },
    });
  }

  policyPageRegistration(apiKey, privacyPageUrl, logoUrl = null) {
    if (window.didomiConfig) {
      window.didomiConfig = {
        app: {
          apiKey: apiKey,
          privacyPolicyURL: privacyPageUrl,
          logoUrl: logoUrl,
        },
      };
      const url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      if (url == window.didomiConfig.app.privacyPolicyURL) {
        window.didomiConfig.notice = { enable: false };
      }
    }
  }

  hasUserGivenConsent(purposeId) {
    if (this.didomi && this.didomi.isConsentRequired()) {
      // Consent is required: your visitor is from the EU or you are an EU company
      return this.didomi.getUserConsentStatusForPurpose(purposeId);
    } else {
      return false;
    }
  }

  hasUserGivenConsentObservable(vendorId) {
    //listen to didomi script loading
    if (this.didomi && this.didomi.isConsentRequired()) {
      this.didomi
        .getObservableOnUserConsentStatusForVendor(vendorId)
        .filter((status) => {
          return status !== undefined;
        })
        .subscribe((consentStatus) => {
          this.trigger("userConsent:changed", consentStatus);
        });
    } else {
      return false;
    }
  }

  hasUserGivenConsentForVendor(vendorId) {
    if (this.didomi && this.didomi.isConsentRequired()) {
      return this.didomi.getUserConsentStatusForVendor(vendorId);
    } else {
      return false;
    }
  }

  showPreferences(view) {
    this.didomi.preferences.show(view);
  }
}



// WEBPACK FOOTER //
// ./src/common/cmp/didomi.js